export default __webpack_public_path__ + "static/media/ic_email.dea04629.svg";